<template>
    <h1>o_kassa_raskhod</h1>
</template>

<script>
export default {

}
</script>

<style>

</style>
